module.exports = __webpack_public_path__ + "static/media/Exhibition_Banner.1cdebdb1.png";